module.exports = __webpack_public_path__ + "static/media/banner_searchbox_icon.be06a58f.svg";